





import { Vue, Component } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  mounted() {
    // window.onresize = (res: any) => {
    if (this._isMobile()) {
      this.$router.replace('/m_index');
    } else {
      this.$router.replace('/');
    }
    //};
  }
  public _isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    );
    return flag;
  }
}
